import React from 'react'

function Pagination(prop) {

  return (
    <>
        <div className='mt-5 flex justify-center'>
            <button className="border-2 border-indigo-500 border-r-0 text-indigo-500 p-2 rounded-l-xl" onClick={prop.goBack}>Previous</button>
            <div className="border-2 border-indigo-500 border-r-0 text-indigo-500 p-2">{prop.pageNumber}</div>
            <button className="border-2 border-indigo-500 text-indigo-500 p-2 rounded-r-xl" onClick={prop.goAhead}>Next</button>
        </div>
    </>
  )
}

export default Pagination
